<script lang="ts">
    import MultiSelectWide from '../../shared/MultiSelectWide.svelte';
    import { app } from '../../../stores/app';
    import { Tooltip } from '@svelte-plugins/tooltips';
    import ButtonMain from '../../shared/ButtonMain.svelte';
    import { tooltip } from '@svelte-plugins/tooltips';
    import JobVisibleSettings from './JobVisibleSettings.svelte';
    import ContextMenu from '../MenuDropdown/Examples/ContextMenu.svelte';
    import MenuContextJobs from '../MenuDropdown/MenuContextJobs.svelte';
    import IconSettings from '../../shared/Icons/IconSettings.svelte';
    import MenuContextIconJobColorMethod from './MenuContextIconJobColorMethod.svelte';
    import SwitchBar from '../../shared/SwitchBar/SwitchBar.svelte';
    import { SwitchBarApp } from '../../shared/SwitchBar/SwitchBarApp';
    import ImportAnalyzeRowDetails from '../Import/ImportAnalyze/ImportAnalyzeRowDetails.svelte';
    import Time from '../../shared/Time.svelte';
    import RoutePointMark from '../Planning/PageDeliveries2/RoutePointMark.svelte';
    import PageRoutePoint from './PageRoutePoint.svelte';
    import PageMultiSelectWideAsync from './MultiSelectWideAsync/PageMultiSelectWideAsync.svelte';

    let switchBarApp: SwitchBarApp = new SwitchBarApp()
        .setItems([
            { id: 'all', label: 'Wszystkie konta' },
            { id: 'standard', label: 'Standardowe' },
            { id: 'technical', label: 'Techniczne' },
        ])
        .selectItems(['standard'])
        .setMultiselect(true, true);

    let selectedItems: string[] = [];
</script>

<div
    style="display: flex; column-gap: 20px; row-gap: 20px; padding: 40px; flex-wrap: wrap; background-color: #fefefe; overflow: auto; height: 100%;"
>
<!--    <div>-->
<!--        <PageRoutePoint />-->
<!--    </div>-->

<!--    <div>-->
<!--        <SwitchBar-->
<!--            {switchBarApp}-->
<!--            onChange={s => {-->
<!--                console.log('onChange', s, switchBarApp.getSelectedItems());-->
<!--                selectedItems = s;-->
<!--            }}-->
<!--        />-->

<!--        <p>{JSON.stringify(selectedItems)}</p>-->
<!--    </div>-->

<!--    <div>-->
<!--        <div>60sec=<Time seconds={60} displayFormat="time" reduceTo24h={false} /></div>-->
<!--        <div>60min=<Time seconds={60 * 60} displayFormat="time" reduceTo24h={false} /></div>-->
<!--        <div>25h=<Time seconds={25 * 60 * 60} displayFormat="time" reduceTo24h={false} /></div>-->
<!--        <div>-->
<!--            25h(reduced to 1h)=<Time-->
<!--                seconds={25 * 60 * 60}-->
<!--                displayFormat="time"-->
<!--                reduceTo24h={true}-->
<!--            />-->
<!--        </div>-->
<!--    </div>-->

<!--    <div>-->
<!--        <MultiSelectWide availableEntries={$app.account.getAvailableLocales()} />-->
<!--    </div>-->

    <div>
        <PageMultiSelectWideAsync  />
    </div>
    <!--    <div>-->
    <!--        <ContextMenu />-->
    <!--    </div>-->
    <!--    <div>-->
    <!--        <MenuContextJobs />-->
    <!--    </div>-->

<!--    <div>-->
<!--        <div class="table">-->
<!--            <ImportAnalyzeRowDetails-->
<!--                reason={{-->
<!--                    reason: 'test',-->
<!--                    value: ['test'],-->
<!--                    original_values: ['test'],-->
<!--                    index: 1,-->
<!--                    checks: [-->
<!--                        { desc: 'test', valid: true },-->
<!--                        { desc: 'test', valid: false },-->
<!--                    ],-->
<!--                }}-->
<!--            />-->
<!--            <ImportAnalyzeRowDetails-->
<!--                reason={{-->
<!--                    reason: 'test',-->
<!--                    value: ['test'],-->
<!--                    original_values: ['test'],-->
<!--                    index: 1,-->
<!--                    checks: [-->
<!--                        { desc: 'test1', valid: true },-->
<!--                        { desc: 'test2', valid: false },-->
<!--                    ],-->
<!--                }}-->
<!--            />-->
<!--        </div>-->
<!--    </div>-->
<!--    &lt;!&ndash;    <div>&ndash;&gt;-->
<!--    &lt;!&ndash;        <MenuContextIconJobColorMethod />&ndash;&gt;-->
<!--    &lt;!&ndash;    </div>&ndash;&gt;-->
<!--    <div>-->
<!--        <span-->
<!--            use:tooltip={{-->
<!--                content: { component: JobVisibleSettings, props: {} },-->
<!--                theme: 'lastmile-tooltip-no-events',-->
<!--                position: 'bottom',-->
<!--                action: 'click',-->
<!--            }}-->
<!--        >-->
<!--            <IconSettings />-->
<!--        </span>-->
<!--    </div>-->
<!--    <div>-->
<!--        <Tooltip-->
<!--            content="Copied!"-->
<!--            position="bottom"-->
<!--            animation="slide"-->
<!--            show={true}-->
<!--            autoPosition-->
<!--            arrow={true}-->
<!--            action="prop"-->
<!--        >-->
<!--            <ButtonMain-->
<!--                text="Copy URL to clipboard"-->
<!--                on:click={() => {-->
<!--                    console.log('Copy URL to clipboard');-->
<!--                }}-->
<!--            />-->
<!--        </Tooltip>-->
<!--    </div>-->
</div>
